import { Card } from "./ui/card";
import { Alert, AlertDescription } from "./ui/alert";
import s from "../styles/modules/FilialInfo.module.scss";
import { Building2, AlertCircle, Loader2 } from "lucide-react";
import Markdown from "react-markdown";
import { useClubInfo } from "../hooks/useClubInfo";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { useHome } from "../hooks/useHome";
import { useClub } from "@/contexts/ClubContext";
import { useGetClientQuery } from "@/queries/useGetClientQuery";
import { AKVASTAR_EMAIL_SUFFIX, INTERNAL_CLUB_ID } from "@/utils/const";

const ClubInfo = () => {
  const { data, isLoading } = useClubInfo();
  const { selectedClubValue, selectClub } = useHome();
  const { clubs } = useClub();
  const { data: clientData } = useGetClientQuery();

  return (
    <Card className="mt-6 transition-colors hover:border-primary">
      <div className="flex flex-col items-start justify-start gap-4 pl-6 pr-6 pt-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-4">
          <div className="rounded-lg bg-primary/10 p-3 text-primary">
            <Building2 className="h-6 w-6" />
          </div>
          <h2 className="text-xl font-medium text-gray-900">Информация о филиале</h2>
        </div>
        <div className="flex items-center justify-end gap-4">
          <span className="pl-2 text-base text-gray-600">Филиал:</span>
          <Select
            value={selectedClubValue}
            onValueChange={(value) => {
              const selectedClub = clubs.find((club) => club.title === value);
              if (selectedClub) {
                selectClub(selectedClub.id);
              }
            }}
          >
            <SelectTrigger className="w-[180px] text-base">
              <SelectValue placeholder="Выберите филиал" />
            </SelectTrigger>
            <SelectContent className="max-h-[200px] text-base">
              {(() => {
                const email = clientData?.email || "";
                const isStaffEmail = email.endsWith(AKVASTAR_EMAIL_SUFFIX);
                const filteredClubs = isStaffEmail
                  ? clubs
                  : clubs.filter((club) => club.id !== INTERNAL_CLUB_ID);

                return filteredClubs.map(({ title }, i) => (
                  <SelectItem key={i} value={title} className="text-base">
                    {title}
                  </SelectItem>
                ));
              })()}
            </SelectContent>
          </Select>
        </div>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center p-8 text-muted-foreground">
          <div className="flex items-center gap-2">
            <Loader2 className="h-5 w-5 animate-spin" />
            <span>Загрузка...</span>
          </div>
        </div>
      ) : data ? (
        <div className={s.text_info}>
          <div className="p-6">
            <Markdown>{data}</Markdown>
          </div>
        </div>
      ) : (
        <div className="p-6">
          <Alert variant="muted">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>Информация о филиале недоступна</AlertDescription>
          </Alert>
        </div>
      )}
    </Card>
  );
};

export default ClubInfo;
